module.exports = __webpack_public_path__ + "static/media/front-image.1ac11fc2.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/front-image.png
 ** module id = 430
 ** module chunks = 0
 **/